import React from "react";
import "./WhatsAppButton.css";
import whatsapp from "../assets/images/whatsapp.jpg";

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "918050254649"; // Replace with your WhatsApp number
    const message = "You are now contacting Little Smiles Photography. Please click on Continue to Chat and post your query."; // Pre-filled message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="whatsapp-button" onClick={handleWhatsAppClick}>
      <img src={whatsapp} alt="WhatsApp" />
    </div>
  );
};

export default WhatsAppButton;
